import React from 'react';
import { StyleSheet, View } from 'react-native';
import Typography from '../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens } from '@voltmoney/schema';
const TooltipComp = ({ title = "", textColor = ColorTokens.Grey_Charcoal, bgColor = ColorTokens.White, fontSize = FontSizeTokens.SM, fontFamily = FontFamilyTokens.Inter, leftShiftContent = -215, // for shifting of tooltip pointer
padding = 16, width = 272, tooltipContainerBottomPosition = 30, tooltipArrowLeftPosition = 1, tooltipArrowBottomPosition = 22, children, }) => {
    return (React.createElement(View, null,
        React.createElement(View, { style: [styles.tooltip,
                { backgroundColor: bgColor,
                    transform: [{ translateX: leftShiftContent }],
                    padding: padding,
                    width: width,
                    bottom: tooltipContainerBottomPosition
                }] },
            React.createElement(Typography, { label: title, fontFamily: fontFamily, fontSize: fontSize, lineHeight: 18, fontWeight: '400', color: textColor }),
            children),
        React.createElement(View, { style: [styles.triangle, styles.arrowDown, { bottom: tooltipArrowBottomPosition, left: tooltipArrowLeftPosition }] })));
};
const styles = StyleSheet.create({
    tooltip: {
        position: 'absolute',
        zIndex: 1,
        borderRadius: 8,
        left: '50%',
        shadowColor: '#000000',
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.17,
        shadowRadius: 17,
        elevation: 8,
    },
    triangle: {
        width: 0,
        height: 0,
        backgroundColor: 'transparent',
        borderStyle: 'solid',
        zIndex: 1,
    },
    arrowDown: {
        position: 'absolute',
        borderTopWidth: 8,
        borderRightWidth: 8,
        borderBottomWidth: 0,
        borderLeftWidth: 8,
        borderTopColor: 'white',
        borderRightColor: 'transparent',
        borderBottomColor: 'transparent',
        borderLeftColor: 'transparent',
        zIndex: 1,
    },
});
export default TooltipComp;
